module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d458676cda22e1f03779482da4a2bdf0.png";